import api from '../../api'
import { FunnelHistoryData } from './historyModel'

export const getInvoicingFunnelHistory = async () => {
  const response = await api.get<FunnelHistoryData>('/web/admin/invoicing-funnel/history')
  return response.data
}

export const refreshInvoicingFunnelHistory = async () => {
  await api.post('/web/admin/invoicing-funnel/history/refresh')
}
